import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
	providedIn: 'root',
})
export class ImageService {
	private readonly BASE_PATH = 'image';

	constructor(private api: ApiService) {}

	/**
	 * Get existing image URLs from a specific table and column
	 */
	public async getExistingImageUrlsByPath$(table: string, column: string): Promise<string[]> {
		const params = {
			table,
			column,
		};

		return firstValueFrom(
			this.api.get<string[]>(`${this.BASE_PATH}/existing-image-urls-by-path`, { params })
		);
	}
}
